module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lines_layer_on-374bcae18d7fe7de5f9548c12dd9f675.png";